import { render, staticRenderFns } from "./AbsenceConfirmWaitingWidget.vue?vue&type=template&id=37a66d18&scoped=true&"
import script from "./AbsenceConfirmWaitingWidget.vue?vue&type=script&lang=js&"
export * from "./AbsenceConfirmWaitingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a66d18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a66d18')) {
      api.createRecord('37a66d18', component.options)
    } else {
      api.reload('37a66d18', component.options)
    }
    module.hot.accept("./AbsenceConfirmWaitingWidget.vue?vue&type=template&id=37a66d18&scoped=true&", function () {
      api.rerender('37a66d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/absences/widgets/AbsenceConfirmWaitingWidget.vue"
export default component.exports